import { type HelpScreen, helpUrl } from "./links";

/**
 * A small ? that opens Fieldpath's help for one part of a screen (Act as). A link, in this tab,
 * like every link to Fieldpath here: a new tab would start with an empty sign-in cache.
 */
export function HelpQ({ screen, label }: { screen: HelpScreen; label: string }) {
  return (
    <a className="help-q" href={helpUrl(screen)} title={label} aria-label={label}>
      ?
    </a>
  );
}
